import { render } from "./HyDetailPage.vue?vue&type=template&id=15b0f4b0&scoped=true"
import script from "./HyDetailPage.vue?vue&type=script&lang=js"
export * from "./HyDetailPage.vue?vue&type=script&lang=js"

import "./HyDetailPage.vue?vue&type=style&index=0&id=15b0f4b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b0f4b0"]])

export default __exports__